import Checkbox, { CheckboxProps } from '@anm/components/form/Checkbox';
import { ChangeEvent, FC } from 'react';
import styled, { css } from 'styled-components';

export type CheckboxItemClickProps = { title: string; description?: string };
export type CheckboxItemProps = CheckboxProps & {
  title: string;
  onClick: (props: CheckboxItemClickProps) => void;
  placeholder?: string;
};

const CheckboxWrapper = styled(Checkbox)`
  top: 4px;
`;

const Label = styled.span`
  font-size: 16px;
  line-height: 25px;
`;
const Container = styled.div`
  margin-left: 10px;
`;

const Wrapper = styled.div<{ checked: boolean }>`
  padding: 13px;
  display: flex;
  align-items: baseline;

  cursor: pointer;
  background: #ffffff;
  border: 1px solid rgba(0, 56, 87, 0.2);
  border-radius: 5px;

  ${({ checked }) =>
    checked &&
    css`
      background: #d9f2ff;
      border: 1px solid rgba(0, 56, 87, 0.2);
    `}
`;

const InputField = styled.input`
  min-width: 350px;
  padding: 10px;
  margin-top: 7px;

  background: #ffffff;
  height: 40px;
  border: 1px solid rgba(0, 56, 87, 0.2);
  border-radius: 5px;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
`;

const CheckboxItem: FC<CheckboxItemProps> = ({ title, checked, placeholder, onClick, ...otherProps }) => {
  return (
    <Wrapper checked={checked} onClick={() => onClick({ title })}>
      <CheckboxWrapper checked={checked} {...otherProps} />
      <Container>
        <Label>{title}</Label>
        {checked && placeholder && (
          <InputField
            autoFocus
            placeholder={placeholder}
            onChange={({ target }: ChangeEvent<HTMLInputElement>) => onClick({ title, description: target.value })}
          />
        )}
      </Container>
    </Wrapper>
  );
};

export default CheckboxItem;
